import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

interface AlertDeleteProps {
  show?: boolean;
  alertHeader?: string;
  alerMessage?: React.ReactNode;
  handleClose?: () => void;
  buttonText?: string;
}

function AlertDelete(props: AlertDeleteProps) {
  let { show, alertHeader, alerMessage, handleClose, buttonText } = props;
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{alertHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mt-3">{alerMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {buttonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AlertDelete;
